import { render, staticRenderFns } from "./PostmortemDetails.vue?vue&type=template&id=1181323a&scoped=true&"
import script from "./PostmortemDetails.vue?vue&type=script&lang=js&"
export * from "./PostmortemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1181323a",
  null
  
)

export default component.exports